import { Check } from 'lucide-react'

// Summary + "Points clés" box shown just under the article meta. Shows the
// article summary (Sanity excerpt) and, when present, the key-takeaways list.
// Renders nothing when both are empty.
export function KeyTakeaways({
  items,
  title,
  summary,
  summaryTitle,
}: {
  items?: string[]
  title: string
  summary?: string
  summaryTitle: string
}) {
  if (!summary && !items?.length) return null
  return (
    <aside className="mt-8 rounded-2xl border border-border bg-muted/40 p-6">
      {summary && (
        <div className={items?.length ? 'mb-5' : undefined}>
          <p className="font-serif text-base font-semibold text-primary">
            {summaryTitle}
          </p>
          <p className="mt-3 text-sm text-secondary-foreground">{summary}</p>
        </div>
      )}
      {items?.length ? (
        <div>
          <p className="font-serif text-base font-semibold text-primary">
            {title}
          </p>
          <ul className="mt-3 space-y-2">
            {items.map((item, i) => (
              <li
                key={i}
                className="flex gap-2.5 text-sm text-secondary-foreground"
              >
                <Check className="mt-0.5 size-4 shrink-0 text-primary" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </aside>
  )
}
